import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Bundled webfonts (offline + CSP-safe): Inter for UI, JetBrains Mono for technical data.
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./index.css";
import App from "./App.tsx";
import { initCrypto } from "./crypto/core";
import { PublicShareView } from "./ui/PublicShareView";

const root = createRoot(document.getElementById("root")!);

// Public one-time-share recipient page (/s/{id}#k=…&s=…): the recipient has NO account and needs
// neither the WASM vault crypto nor the auth/OIDC flow — the payload is decrypted with the key in the
// URL fragment via native WebCrypto. Mount it standalone, skipping initCrypto() and <App/> entirely.
if (typeof location !== "undefined" && location.pathname.startsWith("/s/")) {
  root.render(
    <StrictMode>
      <PublicShareView />
    </StrictMode>,
  );
} else {
  // Initialize the WASM crypto core before mounting (vault crypto runs in the browser, §4).
  initCrypto().finally(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
}
